const BloemenInfoPopup = props => {
    return (
        <div className={"popup-bloem__info-container"}>
            <p><strong>Naam: </strong>{props.name}</p>
            <p><strong>Beschrijving: </strong>{props.description}</p>
            <p><strong>Herkomst: </strong>{props.location}</p>
        </div>
    )
}
export default BloemenInfoPopup